import { render, staticRenderFns } from "./GrTextBlock.vue?vue&type=template&id=48882e6b&scoped=true&"
import script from "./GrTextBlock.vue?vue&type=script&lang=ts&"
export * from "./GrTextBlock.vue?vue&type=script&lang=ts&"
import style0 from "./GrTextBlock.vue?vue&type=style&index=0&id=48882e6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48882e6b",
  null
  
)

export default component.exports